import{useEffect as r,useRef as n}from"react";function t(t,c){var u,e=(u=n(!0),r(function(){u.current=!1},[]),u.current),o=n(t);r(function(){o.current=t},[t]),r(function(){if(!e)return o.current()},c)}export{t as useEffectAfterMount};
//# sourceMappingURL=index.m.js.map
